import Tag from 'packages/cosell/src/components/Tag/Tag';
import { fontWeightMediumLarge } from 'utils/fontWeightConstants';
import { makeStyles } from 'vendor/material';
import ToolTipCopy from 'packages/cosell/src/components/ToolTipCopy/ToolTipCopy';

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    gap: theme.spacing(1),
    flexWrap: 'wrap',
  },
  tagText: {
    fontWeight: fontWeightMediumLarge,
    fontSize: theme.typography.pxToRem(12),
    letterSpacing: '0.3px',
    lineHeight: theme.typography.pxToRem(12),
    color: theme.palette.NEUTRAL400,
  },
}));

const TagsList = ({
  style,
  tags,
}: {
  style?: React.CSSProperties;
  tags: { copyable?: boolean; label: string; value?: string }[];
}) => {
  const classes = useStyles();

  return (
    <div className={classes.container} style={style}>
      {tags.map(({ copyable, label, value }, i) => (
        <Tag key={`${label}${i}`}>
          <span className={classes.tagText}>
            {copyable ? (
              <ToolTipCopy
                content={value}
                name={`${label}: `}
                hideNameInTooltip={true}
              />
            ) : (
              <>
                {label}: {value ?? ' - '}
              </>
            )}
          </span>
        </Tag>
      ))}
    </div>
  );
};

export default TagsList;
